import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../hooks/useAuth';
import { useForm } from 'react-hook-form';
import { DevTool } from '@hookform/devtools'
// Config
import {

  STOCKTRANSACTIONS_BASE_URL

} from '../config';
// Components
import Knoppie from './Knoppie'
import Header from './Header'
import Home from './Home';
import Thumb from './Thumb';

// Hook
import { useEmployeeListFetch } from '../hooks/useEmployeeList';
import { useStockitemsListFetch } from '../hooks/useStockitemsListFetch';
import { useWarehouseListFetch } from '../hooks/useWarehouseListFetch';
import {useUserListFetch} from '../hooks/useUserListFetch'
// Image

let renderCount = 0

const Transaction = () => {

  const auth = useAuth();
  const {transactiontype, stockitem } = useParams()
  console.log(transactiontype)
  const navigate = useNavigate();
  const location = useLocation();
  
  const from = location.state?.from || "../";
  const { state, loading, error, setSearchValue, setIncludeInactive, setLoading, setTrigger } = useStockitemsListFetch();
  const { statewh, loadingwh, errorwh, setSearchValuewh, setIncludeInactivewh, setLoadingwh, setTriggerwh } = useWarehouseListFetch();
  const { userState,userLoading,userError,setUserSearchValue,setUserIncludeInactive,setUserLoading,setUserTrigger } = useUserListFetch();
  
  
  const { register, control, setValue, watch, handleSubmit, formState } = useForm({
    defaultValues: {
      stockitem: stockitem || "" 
    }
  });
  const { errors } = formState
  const transactionType = ["Purchase", "Transfer", "Sale"]
  const selectedtransactionType = watch("transactionType", transactiontype || "")
 
  const [errMessage, setErrMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
 
  console.log(" from = " + from)
  console.log(state)
  console.log(statewh)

  useEffect(() => {
    if (stockitem !== "") {
      setValue("stockitem", stockitem);
    }
  }, [stockitem, setValue]);

  const onSubmit = async data => {

    console.log("Form Submitted", data)

    try {
      const response = await axios.post(`${STOCKTRANSACTIONS_BASE_URL}`,
        JSON.stringify({ data: data }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );

      navigate(from, { replace: true });

    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.response?.status === 500) {

        setErrMessage(error.response?.data.msg.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }


  }
  renderCount++
  return (
    <>
      <h1>RenderCount {renderCount / 2}</h1>
      <Header username={username} role={access} Login={false}></Header>
      <Knoppie
        destination={from}
        text={'Back'}
        clickable
      />

      <section>

        <p >
          {errMessage}
        </p>
      </section>
      <form onSubmit={handleSubmit(onSubmit)} noValidate className="FormClass">

        <h1>Stock transaction:</h1>

        <div className='Lineitem'>
          <label>Transaction Type </label>
          <select
            className="inputsize"
            {...register('transactionType', { required: 'Type is required' })}
           
          >
            <option value="">Select a transaction type</option> {/* Default option */}

            {transactionType.map((type, index) => (
              <option key={index} value={type} selected={selectedtransactionType === type}>
                {type}
              </option>
            ))}
          </select>
          <p className='error'>{errors.transactionType?.message}</p>
        </div>
        <div className='Lineitem'>
          <label>Stockitem </label>
          <select
            className="inputsize"
            {...register('stockitem', { required: 'Stockitem is required' })}
            defaultValue={stockitem}
          >
            <option value="">Select a Stockitem</option> {/* Default option */}

            {state?.stockitems?.map((stockitem) => (
              <option key={stockitem._id} value={stockitem._id} selected={stockitem === stockitem}>
                {stockitem.desc}
              </option>
            ))}
          </select>
          <p className='error'>{errors.stockitem?.message}</p>
        </div>

        {(selectedtransactionType === "Transfer" || selectedtransactionType === "Sale") && (
          <div className='Lineitem'>
            <label>Despatch Warehouse </label>
            <select
              className="inputsize"
              {...register('despatchWarehouse', { required: 'Warehouse is required' })}
            >
              <option value="">Select a Warehouse</option> {/* Default option */}

              {statewh?.warehouses?.map((warehouse) => (
                <option key={warehouse._id} value={warehouse._id}>
                  {warehouse.name}
                </option>
              ))}
            </select>
            <p className='error'>{errors.despatchWarehouse?.message}</p>
          </div>
        )}

        {(selectedtransactionType === "Transfer" || selectedtransactionType === "Purchase") && (
          <div className='Lineitem'>
            <label>Receiving Warehouse </label>
            <select
              className="inputsize"
              {...register('receiveWarehouse', { required: 'Warehouse is required' })}
            >
              <option value="">Select a Warehouse</option> {/* Default option */}

              {statewh?.warehouses?.map((warehouse) => (
                <option key={warehouse._id} value={warehouse._id}>
                  {warehouse.name}
                </option>
              ))}
            </select>
            <p className='error'>{errors.receiveWarehouse?.message}</p>
          </div>
        )}

        <div className='Lineitem'>
          <label>Quantity</label>
          <input className="inputsize" type={"number"} {...register('quantity')} />

        </div>
        <div className='Lineitem'>
          <label>date</label>
          <input className="inputsize" type={"date"} {...register('timestamp')} />

        </div>
        <div className='Lineitem'>
            <label>Receiving User </label>
            <select
              className="inputsize"
              {...register('receiveUser', { required: 'Warehouse is required' })}
            >
              <option value="">Select a User</option> {/* Default option */}

              {userState?.users?.map((user) => (
                <option key={user._id} value={user._id}>
                  {user.username}
                </option>
              ))}
            </select>
            <p className='error'>{errors.receiveUser?.message}</p>
          </div>


        <button>Submit</button>
      </form>

      <DevTool control={control} />

    </>
  )
};

export default Transaction;
